export const EQUIPMENT_CATEGORIES = '/loja/categorias'
